module.exports = {
      id: "edit-usage",
      viewBox: "0 96 960 960",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#edit",
      toString: function () {
        return this.url;
      }
    }